module.exports = __webpack_public_path__ + "static/media/logo.451ca83a.svg";